var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 2.50001H8.38359L6.25 0.366412C6.13435 0.249834 5.99668 0.157407 5.84499 0.0945056C5.6933 0.0316038 5.53062 -0.000518312 5.36641 6.32418e-06H1.25C0.918479 6.32418e-06 0.600537 0.131702 0.366116 0.366123C0.131696 0.600543 0 0.918486 0 1.25001V12.5484C0.00041343 12.867 0.127139 13.1724 0.352386 13.3976C0.577633 13.6229 0.883015 13.7496 1.20156 13.75H15.0695C15.3825 13.7496 15.6825 13.6251 15.9038 13.4038C16.1251 13.1825 16.2496 12.8825 16.25 12.5695V3.75001C16.25 3.41849 16.1183 3.10054 15.8839 2.86612C15.6495 2.6317 15.3315 2.50001 15 2.50001ZM1.25 1.25001H5.36641L6.61641 2.50001H1.25V1.25001ZM15 12.5H1.25V3.75001H15V12.5Z",
    fill: "#343330",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.d05391a89b06b5085b5a6dfab8ce5392.svg";
export { ForwardRef as ReactComponent };